import {combineReducers} from "redux";
import userInfo from "./userInfo";
import removedSegments from "./removedSegments";
import optInOut from "./optInOut";

export default combineReducers({userInfo, removedSegments, optInOut});